import clsx from "clsx";
import { Col, ModalProps, useModal } from "@commonlibs";
import { createModal } from "@commonlibs";
import type { LocalGiftCardDto } from "common/models/api/models/LocalGiftCardDto";
import Modal from "ui/common/components/feedback/Modal/Modal";
import ModalFooter from "ui/common/components/feedback/Modal/ModalFooter/ModalFooter";
import useTranslate from "ui/locale/hooks/useTranslate";
import GiftCardModal from "../GiftCardForm/GiftCardFormModal";
import { CheckboxGroup } from "ui/common/components/input/CheckboxGroup/CheckboxGroup";
import { useFormatNumber } from "ui/common/hooks/useFormatNumber";

const GiftCardValuesModal = createModal<{ giftCard: LocalGiftCardDto } & ModalProps>(({ className, giftCard, ...rest }) => {
    const translate = useTranslate();
    const { hideModal, showModal } = useModal();
    const formatNumber = useFormatNumber();

    function closeModal() {
        hideModal(GiftCardValuesModal.id);
    }

    function onEdit() {
        hideModal(GiftCardValuesModal.id);
        setTimeout(() => {
            showModal(GiftCardModal, { giftCard });
        }, 500);
    }

    return (
        <Modal
            title={translate("giftCardValue")}
            className={clsx("modify-movements-modal", className)}
            style={{ width: "550px" }}
            {...rest}
        >
            <Col style={{ marginBottom: "25px" }}>
                <CheckboxGroup
                    options={giftCard.denominations.map((item) => ({
                        label: formatNumber(item.value, { useGrouping: true }),
                        value: item.value,
                    }))}
                    value={giftCard.denominations.map((item) => item.value)}
                    gap={25}
                    direction="row"
                />
            </Col>
            <ModalFooter cancelLabel={translate("goOut") as string} mainLabel={translate("edit")} onCancel={closeModal} onSubmit={onEdit} />
        </Modal>
    );
});

export default GiftCardValuesModal;
